"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ReferenceResolver = require("reference-resolvers/ReferenceResolver");

var _ResolverLoading = _interopRequireDefault(require("reference-resolvers/schema/ResolverLoading"));

var _ResolverError = _interopRequireDefault(require("reference-resolvers/schema/ResolverError"));

var _immutable = require("immutable");

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var _updateIn = _interopRequireDefault(require("transmute/updateIn"));

var _curry = _interopRequireDefault(require("transmute/curry"));

var _hasIn = _interopRequireDefault(require("transmute/hasIn"));

var _isEmpty = _interopRequireDefault(require("transmute/isEmpty"));

var _always = _interopRequireDefault(require("transmute/always"));

var _indexBy = _interopRequireDefault(require("transmute/indexBy"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _merge = _interopRequireDefault(require("transmute/merge"));

var _get = _interopRequireDefault(require("transmute/get"));

var _ifThen = _interopRequireDefault(require("transmute/ifThen"));

var _atom = require("atom");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var not = (0, _curry.default)(function (test, subject) {
  return !test(subject);
});

var createCache = function createCache(atom) {
  (0, _atom.swap)(atom, (0, _ifThen.default)(_isEmpty.default, (0, _always.default)((0, _immutable.Map)({
    idQueue: (0, _immutable.Set)(),
    objects: (0, _immutable.Map)()
  }))));
  return {
    queueId: function queueId(id) {
      (0, _atom.swap)(atom, (0, _ifThen.default)(not((0, _hasIn.default)(['objects', id])), (0, _updateIn.default)(['idQueue'], function (queue) {
        return queue.add(id);
      })));
    },
    getQueue: function getQueue() {
      var queue = (0, _atom.deref)(atom).get('idQueue');
      return queue;
    },
    loadingData: function loadingData(ids) {
      var newObjects = (0, _indexBy.default)(_identity.default, ids).map(function () {
        return (0, _immutable.Map)({
          loading: true,
          reference: null
        });
      });
      (0, _atom.swap)(atom, function (state) {
        return state.update('objects', (0, _merge.default)(newObjects)).update('idQueue', function (queue) {
          return queue.subtract(ids);
        });
      });
    },
    loadingDataFailed: function loadingDataFailed(ids, e) {
      var newObjects = (0, _indexBy.default)(_identity.default, ids).map(function () {
        return (0, _immutable.Map)({
          loading: false,
          error: e,
          reference: null
        });
      });
      (0, _atom.swap)(atom, (0, _updateIn.default)(['objects'], (0, _merge.default)(newObjects)));
    },
    loadedData: function loadedData(ids, references) {
      var newObjects = (0, _indexBy.default)((0, _get.default)('id'), references).map(function (reference) {
        return (0, _immutable.Map)({
          loading: false,
          reference: reference
        });
      });
      var missing = (0, _indexBy.default)(_identity.default, ids.filter(function (id) {
        return !newObjects.has(id);
      })).map(function () {
        return (0, _immutable.Map)({
          loading: false,
          reference: null
        });
      });
      (0, _atom.swap)(atom, (0, _updateIn.default)(['objects'], (0, _merge.default)(newObjects.merge(missing))));
    },
    listen: function listen(onUpdate) {
      onUpdate((0, _atom.deref)(atom));
      (0, _atom.watch)(atom, onUpdate);
      return function () {
        (0, _atom.unwatch)(atom, onUpdate);
      };
    }
  };
};

var createBatchedReferenceResolver = function createBatchedReferenceResolver(_ref) {
  var cacheKey = _ref.cacheKey,
      createFetchSearchPage = _ref.createFetchSearchPage,
      createFetchByIds = _ref.createFetchByIds,
      fetchSearchPage = _ref.fetchSearchPage,
      fetchByIds = _ref.fetchByIds,
      httpClient = _ref.httpClient,
      _ref$debouncePeriod = _ref.debouncePeriod,
      debouncePeriod = _ref$debouncePeriod === void 0 ? 500 : _ref$debouncePeriod;
  (0, _invariant.default)(cacheKey && typeof cacheKey === 'string', 'expected `cacheKey` to be a non-empty string');

  if (httpClient) {
    (0, _invariant.default)(!!(createFetchSearchPage || createFetchByIds), 'createFetchSearchPage or createFetchByIds factory function not provided for supplied httpClient for batched resolver');
    fetchSearchPage = createFetchSearchPage && createFetchSearchPage({
      httpClient: httpClient
    });
    fetchByIds = createFetchByIds && createFetchByIds({
      httpClient: httpClient
    });
  }

  return function (getCacheAtom) {
    var cache = createCache(getCacheAtom(cacheKey));
    var makeBatchedIdRequest = (0, _debounce.default)(debouncePeriod, function () {
      var ids = cache.getQueue();

      if (ids.size > 0) {
        cache.loadingData(ids);
        fetchByIds(ids.toArray()).then(function (results) {
          return cache.loadedData(ids, results);
        }, function (e) {
          cache.loadingDataFailed(ids, e);
        });
      }
    });

    var queueIdFetch = function queueIdFetch(id) {
      cache.queueId(id);
      makeBatchedIdRequest();
    };

    return (0, _ReferenceResolver.makeReferenceResolver)({
      byId: function byId(id, next) {
        return cache.listen(function (state) {
          var object = state.getIn(['objects', id]);
          var queued = state.hasIn(['idQueue', id]);

          if (object == null) {
            if (!queued) {
              queueIdFetch(id);
              next((0, _ResolverLoading.default)({
                startDate: Date.now()
              }));
            }
          } else if (object.get('error')) {
            next((0, _ResolverError.default)({
              reason: object.get('error')
            }));
          } else if (!object.get('loading')) {
            next(object.get('reference'));
          }
        });
      },
      search: function search(query, next) {
        next((0, _ResolverLoading.default)({
          startDate: Date.now()
        }));
        fetchSearchPage(query).then(next).catch(function (e) {
          return next((0, _ResolverError.default)({
            reason: e
          }));
        });
        return function () {};
      }
    }, "BatchedReferenceResolver_" + cacheKey);
  };
};

var _default = createBatchedReferenceResolver;
exports.default = _default;
module.exports = exports.default;